import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Hero() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = searchQuery.trim();
    if (trimmed) {
      navigate(`/?q=${encodeURIComponent(trimmed)}`);
    }
  };

  // Helper for the “popular searches” buttons – creates a minimal FormEvent
  const triggerSearch = (query: string) => {
    setSearchQuery(query);
    // Create a synthetic event with only preventDefault implemented
    const fakeEvent = {
      preventDefault: () => {},
    } as unknown as React.FormEvent;
    handleSearch(fakeEvent);
  };

  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      {/* Arka Plan Görseli */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20minimalist%20shopping%20abstract%20geometric%20pattern%20with%20elegant%20product%20displays%20luxury%20retail%20aesthetic%20soft%20gradient%20background%20rose%20orange%20tones%20premium%20ecommerce%20atmosphere%20clean%20professional%20design%20sophisticated%20outlet%20theme&width=1920&height=1080&seq=hero-bg-modern&orientation=landscape"
          alt="Hero Background"
          className="w-full h-full object-cover"
        />
        {/* Koyu Gradient Overlay - Okunabilirlik için */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center space-x-2 bg-white/15 backdrop-blur-md px-4 py-2 rounded-full mb-8 border border-white/30">
            <span className="w-2 h-2 bg-rose-500 rounded-full animate-pulse"></span>
            <span className="text-sm font-medium text-white drop-shadow-lg">
              Binlerce ürün, tek platformda
            </span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight drop-shadow-2xl">
            En İyi Outlet
            <span className="block bg-gradient-to-r from-rose-400 to-orange-400 bg-clip-text text-transparent drop-shadow-lg">
              Fırsatlarını Kaçırma
            </span>
          </h1>

          <p className="text-lg md:text-xl text-white mb-10 max-w-2xl mx-auto leading-relaxed drop-shadow-lg font-medium">
            Tüm markaların outlet ve indirim ürünlerini tek platformda topladık.
            Fiyat takibi yap, bildirim al, en uygun fırsatları yakala.
          </p>

          {/* Arama Kutusu */}
          <form onSubmit={handleSearch} className="max-w-3xl mx-auto mb-8">
            <div className="relative">
              <input
                type="text"
                placeholder="Ürün, marka veya kategori ara..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full px-6 py-4 pr-32 text-sm bg-white/95 backdrop-blur-sm rounded-xl shadow-lg border border-white/20 focus:outline-none focus:ring-2 focus:ring-rose-500 focus:border-transparent text-gray-900"
              />
              <button
                type="submit"
                className="absolute right-2 top-1/2 -translate-y-1/2 px-6 py-2.5 bg-gradient-to-r from-rose-500 to-orange-500 text-white text-sm font-medium rounded-lg hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-search-line mr-2"></i>
                Ara
              </button>
            </div>
          </form>

          {/* Popüler Aramalar */}
          <div className="flex flex-wrap items-center justify-center gap-3 text-sm">
            <span className="font-medium text-white drop-shadow-lg">
              Popüler Aramalar:
            </span>
            <button
              onClick={() => triggerSearch("Nike Ayakkabı")}
              className="px-4 py-2 bg-white/15 backdrop-blur-md text-white rounded-full hover:bg-white/25 transition-colors cursor-pointer whitespace-nowrap border border-white/30 drop-shadow-lg"
            >
              Nike Ayakkabı
            </button>
            <button
              onClick={() => triggerSearch("Zara Giyim")}
              className="px-4 py-2 bg-white/15 backdrop-blur-md text-white rounded-full hover:bg-white/25 transition-colors cursor-pointer whitespace-nowrap border border-white/30 drop-shadow-lg"
            >
              Zara Giyim
            </button>
            <button
              onClick={() => triggerSearch("Spor Ayakkabı")}
              className="px-4 py-2 bg-white/15 backdrop-blur-md text-white rounded-full hover:bg-white/25 transition-colors cursor-pointer whitespace-nowrap border border-white/30 drop-shadow-lg"
            >
              Spor Ayakkabı
            </button>
            <button
              onClick={() => triggerSearch("Kozmetik")}
              className="px-4 py-2 bg-white/15 backdrop-blur-md text-white rounded-full hover:bg-white/25 transition-colors cursor-pointer whitespace-nowrap border border-white/30 drop-shadow-lg"
            >
              Kozmetik
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
